var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('multiselect',{staticClass:"form-control",attrs:{"options":_vm.datos,"track-by":"id","label":"nombre","searchable":true,"close-on-select":true,"show-labels":false,"placeholder":"Seleccione..."},model:{value:(_vm.modelo.idempresa),callback:function ($$v) {_vm.$set(_vm.modelo, "idempresa", $$v)},expression:"modelo.idempresa"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }